import { ClearFiltersButton, EmptyStateContainer, SubTitle, Title } from './styled';

export type FiltersApplied = {
  onClearFilters: () => void;
  subTitleFilters?: string;
};

type Props = {
  title: string;
  subTitle: string;
  filtersApplied?: FiltersApplied;
};

const EmptyState = ({ title, subTitle, filtersApplied }: Props): JSX.Element => {
  const subTitleText = filtersApplied && filtersApplied.subTitleFilters ? filtersApplied.subTitleFilters : subTitle;

  return (
    <EmptyStateContainer data-testid="emptyState">
      <Title>{title}</Title>
      <SubTitle>{subTitleText}</SubTitle>
      {filtersApplied && (
        <ClearFiltersButton data-testid="clearFilters" onClick={filtersApplied.onClearFilters}>
          Clear Filters
        </ClearFiltersButton>
      )}
    </EmptyStateContainer>
  );
};

export default EmptyState;
